/**
 * Import all files from a glob pattern and return an object with the filename as the key and the default export as the value.
 * @param glob - The glob pattern to import from.
 * @returns An object with the filename as the key and the default export as the value.
 */
export function mapImports(globImports: Record<string, unknown>) {
  return Object.fromEntries(
    Object.entries(globImports).map(([key, value]) => {
      const filename = key.split('/').pop() // get the last segment of the path
      return [filename, (value as { default: unknown }).default]
    }),
  )
}
